import * as _4 from 'lodash4';
import { IQuestionBuilderDTD } from '../../poll_interfaces';
import { IMutatedChoice, IValidationCallbackParams } from '../../types/poll_question_types';

interface IPollChoiceQuestionModel {
  choiceNk: any;
}

export class StandAloneChoicePoll implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-poll/src/components/stand_alone_choice/stand_alone_choice.html';
  public controller: any = 'StandAloneChoicePollController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    question: '<',
    validationCallback: '<?',
    labelledBy: '@'
  };
}

export class StandAloneChoicePollController {
  private models: IPollChoiceQuestionModel;
  private validationCallback: (params: IValidationCallbackParams) => void;
  private question: IQuestionBuilderDTD;

  constructor($state: ng.ui.IStateService) {
    this.models = {
      choiceNk: { nk: '' }
    };
  }

  refresh(): void {
    this.models = {
      choiceNk: this._getChoiceNk()
    };

    this.validate();
  }

  $onInit() {
    this.validationCallback = _4.isFunction(this.validationCallback) ? this.validationCallback : angular.noop;
    this.refresh();
  }

  $onChanges(changeObj: any) {
    if (!_4.isEmpty(changeObj)) {
      this.refresh();
    }
  }

  updateChoice(evt: any, choice: IMutatedChoice) {
    const selectedChoice = JSON.parse(_4.get(evt, 'originalEvent.detail.value', 'false'));
    this.setChoice(selectedChoice ? choice : { nk: '' });
  }

  setChoice(selectedChoice: any) {
    _4.forEach(this.question._active_choices, (choice: IMutatedChoice) => {
      if (choice.nk === selectedChoice.nk) {
        choice.answered = true;
        this.refresh();
      } else {
        choice.answered = false;
      }
    });
    this.validate();
  }

  _getChoiceNk() {
    return _4.isEmpty(this.question)
      ? undefined
      : _4.find(
          this.question._active_choices,
          (choice: IMutatedChoice) => !_4.isUndefined(choice.answered) && choice.answered
        );
  }

  validate(): void {
    const repsonse: string = _4.get(this.models, 'choiceNk');
    this.validationCallback({
      isValid: !_4.isEmpty(repsonse),
      selectedResponse: repsonse
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/stand_alone_choice/stand_alone_choice.ts